import { MarketDetails, CountryOption } from '../../types';
import { useState } from 'react';
import { Collapsable, CollapsableHeader, Icon, Icons, IconState, Typography } from '@/components';
import { useCompanyRole } from '@/features/company/hooks';
import { PriceTrendCanva } from './market-canva';

type MarketListItemProps = {
  readonly market: MarketDetails;
  readonly country: CountryOption;
};

function InfoHeader(updatedAt: string, location: string) {
  return (
    <div className="flex flex-col gap-1 sm:flex-row sm:gap-0">
      <div className="mr-3 flex items-center">
        <Icon name="calendar" className="mr-1 h-4 w-4 text-neutral-700" />
        <Typography as="p" size="body-3" color="primary" weight="normal">
          Last update: {updatedAt}
        </Typography>
      </div>
      <div className="flex items-center">
        <Icon name="map-pin" className="mr-1 h-4 w-4 text-neutral-700" />
        <Typography as="p" size="body-3" color="primary" weight="normal">
          {location}
        </Typography>
      </div>
    </div>
  );
}

export function MarketListItem({ market, country }: MarketListItemProps) {
  const [isExpanded, setIsExpanded] = useState(true);
  const { isFree } = useCompanyRole();

  const {
    technology,
    title,
    description,
    updatedAt,
    prices,
    dataSource,
    priceTrend,
    interestTrend,
    chartTitle,
    descriptionComments,
    interval,
    minYAxis,
    maxYAxis,
  } = market;

  const technologyIcons: IconState[] = [
    {
      icon: technology,
      status: 'active',
    },
  ];

  const pricesToChart = prices.map(({ quarter, max_range, average_price, min_range }) => ({
    quarter: quarter,
    maxRange: max_range,
    averagePrice: average_price,
    minRange: min_range,
  }));

  const data = {
    dataSource,
    prices: pricesToChart,
    technology,
    priceTrend,
    interestTrend,
    chartTitle,
    descriptionComments,
    interval,
    minYAxis,
    maxYAxis,
  };

  const header = (
    <CollapsableHeader
      title={title}
      weight="semibold"
      description={description}
      isExpanded={isExpanded}
      onToggle={() => setIsExpanded((isExpanded) => !isExpanded)}
      icons={<Icons icons={technologyIcons} className="mr-2" size="lg" />}
      childrenHeader={InfoHeader(updatedAt, country.label)}
    />
  );

  return (
      <Collapsable index={0} isExpanded={isExpanded} header={header}>
        <PriceTrendCanva data={data} hidden={isFree} />
      </Collapsable>
  
  );
}
